import { heatRanking, siteStats } from '@/mocks/home';
import SectionHeading from '@/pages/home/components/SectionHeading';

export default function HeatRanking() {
  return (
    <section id="heat" className="w-full px-4 py-12 md:px-8 md:py-16">
      <div className="mx-auto max-w-[1280px]">
        <SectionHeading
          kicker="Heat Ranking / 反差热度榜"
          index="04 — 每 6 小时更新"
          title="反差热度榜 · 本周 Top 8"
          desc="热度由讨论量、条目阅读量与更新频率综合计算，排名每天变化，只反映关注度，不代表任何结论。"
          href="#heat"
        />

        <div className="mt-8 grid grid-cols-1 gap-6 lg:grid-cols-[1fr_320px]">
          <ol className="rounded-lg border border-background-200 bg-background-100">
            {heatRanking.map((item, i) => {
              const isTop = item.rank <= 3;
              const rising = item.delta >= 0;
              return (
                <li
                  key={item.rank}
                  className={`flex flex-wrap items-center gap-x-4 gap-y-3 px-4 py-4 transition-colors hover:bg-background-200 md:flex-nowrap md:px-6 ${
                    i !== heatRanking.length - 1 ? 'border-b border-background-200' : ''
                  }`}
                >
                  <span
                    className={`w-8 shrink-0 font-heading text-2xl font-black md:w-11 md:text-3xl ${
                      isTop ? 'text-primary-500' : 'text-foreground-300'
                    }`}
                  >
                    {String(item.rank).padStart(2, '0')}
                  </span>

                  <div className="min-w-0 flex-1">
                    <div className="flex flex-wrap items-center gap-2">
                      <h3 className="font-heading text-base font-bold text-foreground-950 md:text-lg">
                        <a href="#dossier" className="transition-colors hover:text-primary-600">
                          {item.name}
                        </a>
                      </h3>
                      <span className="rounded-full bg-secondary-100 px-2.5 py-0.5 font-label text-[11px] text-secondary-900">
                        {item.role}
                      </span>
                      {isTop && (
                        <span className="rounded-full bg-accent-100 px-2.5 py-0.5 font-label text-[11px] text-accent-900">
                          本周焦点
                        </span>
                      )}
                    </div>
                    <p className="mt-1 truncate text-sm text-foreground-600">{item.topic}</p>
                  </div>

                  <div className="flex w-full items-center gap-3 md:w-[160px]">
                    <span className="font-heading text-lg font-bold text-foreground-950">{item.heat}</span>
                    <span
                      className={`flex items-center gap-0.5 font-label text-[11px] ${
                        rising ? 'text-secondary-600' : 'text-primary-600'
                      }`}
                    >
                      <i className={rising ? 'ri-arrow-up-line' : 'ri-arrow-down-line'} />
                      {Math.abs(item.delta)}
                    </span>
                    <div className="h-1.5 flex-1 overflow-hidden rounded-full bg-background-300">
                      <div className="h-full rounded-full bg-accent-500" style={{ width: `${item.heat}%` }} />
                    </div>
                  </div>
                </li>
              );
            })}
          </ol>

          <aside className="flex flex-col gap-6">
            <div className="rounded-lg border border-background-200 bg-accent-100 p-5">
              <h3 className="font-heading text-lg font-bold text-accent-950">榜单怎么算的</h3>
              <p className="mt-3 text-sm leading-relaxed text-accent-900">
                讨论量占 50%，条目阅读量占 30%，更新频率占 20%。同一人物多条条目会合并计算，避免单点刷高排名。
              </p>
              <p className="mt-3 border-t border-accent-300/60 pt-3 font-label text-[11px] text-accent-900">
                下次更新：今日 18:00
              </p>
            </div>

            <div className="rounded-lg border border-background-200 bg-background-100 p-5">
              <h3 className="font-heading text-lg font-bold text-foreground-950">站内速览</h3>
              <dl className="mt-4 grid grid-cols-2 gap-4">
                {siteStats.map((stat) => (
                  <div key={stat.label}>
                    <dt className="font-label text-[11px] text-foreground-500">{stat.label}</dt>
                    <dd className="mt-1 font-heading text-lg font-bold text-foreground-950">{stat.value}</dd>
                  </div>
                ))}
              </dl>
            </div>
          </aside>
        </div>
      </div>
    </section>
  );
}